import {Component, ElementRef, inject, Inject, OnInit, ViewChild} from '@angular/core';
import {SpringRestService} from '@aiknow-srl/aik-angular-sdk';
import {GetCustomersCB} from '../../Ope/Customer/GetCustomersCB';
import {Customer} from '../../Models/Customer/Customer';
import {MatTableDataSource} from '@angular/material/table';
import {PageEvent} from '@angular/material/paginator';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {GetAllCustomersCB} from '../../Ope/Customer/GetAllCustomersCB';
import {PutCustomerCB} from '../../Ope/Customer/PutCustomerCB';
import {DelCustomerCB} from '../../Ope/Customer/DelCustomerCB';
import {ChangeCustomerOwnerCB} from '../../Ope/Customer/ChangeCustomerOwnerCB';
import {CustomerDetailComponent} from './customerDetail/customerDetail.component';
import {CustomerService} from "../../Services/Ope/Customer.service";
import {BaseComponent} from "../common/BaseComponent";
import {BaseDialogComponent} from "../common/BaseDialogComponent";
import {FormControl} from "@angular/forms";
import {map, Observable, startWith} from "rxjs";

@Component({
  selector: 'app-customer-registry',
  templateUrl: './customerRegistry.component.html',
  styleUrls: ['./customerRegistry.component.css', '../common/drawer-style.css']
})
export class CustomerRegistryComponent extends BaseComponent implements OnInit {


  @ViewChild(CustomerDetailComponent) customerDetail?: CustomerDetailComponent;

  // ***************************
  //   PAGINATION OPTIONS
  // ***************************
  readonly PAGESIZE_OPTIONS = [10, 20, 30];
  totalPages?: number;
  totalElements: number = 0;
  page = 0;
  pageSize = this.PAGESIZE_OPTIONS[0];

  customers: Customer[];
  allCustomers: Customer[];
  displayedColumns: string[] = ['customerImage', 'title', 'parentCustomerTitle', 'actions'];
  tableDataSource!: MatTableDataSource<Customer>;

  newCustomer?: Customer;
  expandedElement?: Customer;

  customerTitleToFind?: string;

  editMode = false;
  formValidationOk = true;

  customerLoading = false;
  searchEnabled = false;

  private be = inject(SpringRestService);
  public customerService = inject(CustomerService);

  constructor() {
    super();
    this.customers = new Array<Customer>();
    this.allCustomers = new Array<Customer>();
  }

  ngOnInit(): void {
    this.getCustomers();
  }

  getCustomers() {
    this.customerLoading = true;
    this.tableDataSource = new MatTableDataSource();
    const cb = new GetCustomersCB();
    cb.i.pageSize = this.pageSize;
    cb.i.page = this.page;
    cb.i.textSearch = (!!this.customerTitleToFind && this.customerTitleToFind != '') ? this.customerTitleToFind : undefined;

    this.customerService.getCustomers(cb).subscribe(
      () => {
        this.customers = cb.o.customers.sort((a, b) => a.title.localeCompare(b.title));

        this.totalElements = cb.o.totalElements;
        this.totalPages = cb.o.totalPages;
        this.tableDataSource = new MatTableDataSource(this.customers);
        this.customerLoading = false;

        // Update the Expanded element
        if (!!this.expandedElement) {
          this.expandedElement = this.customers.find(a => a.id === this.expandedElement?.id);
        }
        this.editMode = false;

      }, error => {
        this.gmService.openErrorSnackbar(error);
        this.tableDataSource = new MatTableDataSource();
        this.customerLoading = false;
      }
    )
  }

  /**
   * listen to Paginator event
   */
  public getPaginatorData(event: PageEvent): PageEvent {
    this.page = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getCustomers();
    return event;
  }

  addNewCustomer() {
    const cb = new GetAllCustomersCB();
    this.customerService.getAllCustomers(cb).subscribe(
      () => {
        this.allCustomers = cb.o.customers.sort((a, b) => a.title.localeCompare(b.title));

        this.newCustomer = new Customer();

        const dialogRef = this.dialog.open(PutCustomerDialogComponent, {
          width: '600px',
          data: {
            customer: this.newCustomer,
            allCustomers: this.allCustomers
          }
        });

        dialogRef.afterClosed().subscribe(
          (res) => {
            if (!!res) {
              this.gmService.openSuccessSnackbar(this.translate.instant('CUSTOMER.ADD_OK'));
              this.getCustomers();
            }
          }, error => {
            console.log(error);
          }
        );

      }, error => {
        this.gmService.openErrorSnackbar(error);
      }
    );
  }


  updateCustomer() {
    const customer = this.customerDetail?.dataDetail;
    const imageFile = this.customerDetail?.selectedFile

    // CHECK FILE DIMENSION

    if (!!imageFile && imageFile.size > this.gmService.FILE_MAX_SIZE) {
      this.gmService.openErrorSnackbar(this.translate.instant("ERROR.IMAGE_TOO_BIG"));
      return;
    }

    if (!!customer) {
      const cb = new PutCustomerCB();

      cb.i.title = customer.title;
      cb.i.id = customer.id;
      cb.i.parentCustomerId = customer.parentCustomer?.id;
      cb.i.hasImage = !!customer.imageUrl;

      if (!!customer.emails) {
        cb.i.emails = customer.emails.map(email => email.trim());
      } else {
        cb.i.emails = new Array<string>();
      }

      this.customerService.putCustomer(cb).subscribe(
        () => {

          if (!!imageFile) {
            this.be.putEntityImage(this.gmService.composePutImageUrl(this.gmService.PUT_CUSTOMER_IMAGE_SERVICE), imageFile, customer.id).subscribe(
              () => {
                this.gmService.openSuccessSnackbar(this.translate.instant('CUSTOMER.CHANGE_OWNER_OK'));
                this.getCustomers();
              }, err1 => {
                this.gmService.openErrorSnackbar(err1);
              }
            );
          } else {
            this.gmService.openSuccessSnackbar(this.translate.instant('CUSTOMER.CHANGE_OWNER_OK'));
            this.getCustomers();
          }

        }, error => {
          this.gmService.openErrorSnackbar(error);
        }
      )
    }
  }

  deleteCustomer(row: Customer) {
    const dialogRef = this.dialog.open(AreUSureDeleteCustomerDialogComponent, {
      width: '500px',
      data: row.title
    });

    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {

          const cb = new DelCustomerCB();
          cb.i.id = row.id;

          this.customerService.delCustomer(cb).subscribe(
            () => {
              this.gmService.openSuccessSnackbar(this.translate.instant('CUSTOMER.DELETE_OK'));
              this.getCustomers();
            }, error => {
              this.gmService.openErrorSnackbar(error);
            }
          )
        }
      }, error => {
        console.log(error);
      }
    );
  }


  changeCustomerOwner(element: Customer) {

    const cb = new GetAllCustomersCB();
    this.customerService.getAllCustomers(cb).subscribe(
      () => {
        this.allCustomers = cb.o.customers.sort((a, b) => a.title.localeCompare(b.title));

        this.newCustomer = JSON.parse(JSON.stringify(element));

        const dialogRef = this.dialog.open(ChangeCustomerOwnerDialogComponent, {
          width: '600px',
          data: {
            customer: this.newCustomer,
            allCustomers: this.allCustomers
          }
        });

        dialogRef.afterClosed().subscribe(
          (res) => {
            if (!!res) {
              this.gmService.openSuccessSnackbar(this.translate.instant('CUSTOMER.CHANGE_OWNER_OK'));
              this.getCustomers();
            }
          }, error => {
            console.log(error);
          }
        );

      }, error => {
        this.gmService.openErrorSnackbar(error);
      }
    )


  }

  showDetail(element: any): void {

    if (this.checkIsE015(element)) {
      // NO UPDATE IT
      this.expandedElement = undefined;
      return;
    }
    this.editMode = false;
    this.expandedElement = this.expandedElement === element ? undefined : element;
  }

  hideElement() {
    this.expandedElement = undefined;
  }

  filterTableElements() {
    console.log(this.customerTitleToFind)
  }

  checkIsE015(row: Customer) {
    if (!!row.isE015) {
      return row.isE015;
    } else {
      return false;
    }

  }

  manageFormValidation($event: boolean) {
    this.formValidationOk = $event;
  }

}


/*--------------------------------
      PUT CUSTOMER COMPONENT
 -------------------------------*/

@Component({
  templateUrl: 'put-customer-dialog.html',
  selector: 'app-put-customer-dialog',
  styleUrls: ['../common/dialog-style.css']
})
export class PutCustomerDialogComponent extends BaseDialogComponent<PutCustomerDialogComponent> {

  parentId?: string;
  parentCustomer?: Customer;
  selectedFile?: File;
  customerSelectionControl = new FormControl<Customer | string>('');
  emailList: string = '';
  filteredCustomers?: Observable<any>
  @ViewChild('fileInput') fileInput!: ElementRef;

  private be = inject(SpringRestService);
  public customerService = inject(CustomerService);


  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    super();
    this.parentId = data.customer.parentCustomer?.id;

    this.emailList = data.customer.emails?.reduce((a: string, b: string) => `${a},${b}`);
    this.filterCustomer_init();
  }

  //------
  // Filterable customer List
  //------
  filterCustomer_init(){
    this.filteredCustomers = this.customerSelectionControl.valueChanges.pipe(
      startWith(''),
      map( value => {
        if(!!value){
          const title = typeof value === 'string' ? value : (value as unknown as Customer).title;
          return title ? this._filter(title as string) : this.data.allCustomers!.slice()
        } else {
          return this.data.allCustomers!.slice()
        }}),
    );
  }

  private _filter(value: string): Customer[] {
    const filterValue = value.toLowerCase();
    return this.data.allCustomers!.filter((x: Customer)=> x.title.toLowerCase().includes(filterValue));
  }
  displayFn(customer: Customer): string {
    return customer? customer.title : '';
  }
  checkSelection(): boolean {
    if(typeof this.customerSelectionControl.value != 'object') {
      return !!this.customerSelectionControl.value;
    } else {
      return false;
    }
  }

  onFileSelected(fileEvent: any) {

    this.selectedFile = fileEvent.target.files[0];
    console.log(this.selectedFile)
  }

  resetImage() {
    this.selectedFile = undefined;
    this.fileInput.nativeElement.value = '';
  }

  saveCustomer(customer: Customer) {

    // CHECK FILE DIMENSION

    if (!!this.selectedFile && this.selectedFile.size > this.gmService.FILE_MAX_SIZE) {
      this.gmService.openErrorSnackbar(this.translate.instant("ERROR.IMAGE_TOO_BIG"));
      return;
    }

    const cb = new PutCustomerCB();

    cb.i.title = customer.title;
    cb.i.id = customer.id;
    cb.i.parentCustomerId = this.parentId;
    cb.i.hasImage = !!this.selectedFile;

    if (!!this.emailList) {
      cb.i.emails = this.emailList.split(',');
    } else {
      cb.i.emails = new Array<string>();
    }

    this.customerService.putCustomer(cb).subscribe(
      () => {

        if (!!this.selectedFile && !!cb.o.id) {
          this.be.putEntityImage(this.gmService.composePutImageUrl(this.gmService.PUT_CUSTOMER_IMAGE_SERVICE), this.selectedFile, cb.o.id).subscribe(
            () => {
              this.closeDialog(true)
            }, err1 => {
              this.gmService.openErrorSnackbar(err1);
            }
          );
        } else {
          // NO IMAGE
          this.dialogRef.close(true);
        }


      }, error => {
        this.gmService.openErrorSnackbar(error);
      }
    )
  }
}


/*--------------------------------
  CHANGE CUSTOMER OWNER COMPONENT
 -------------------------------*/

@Component({
  templateUrl: 'change-customer-owner-dialog.html',
  selector: 'app-change-customer-owner-dialog',
  styleUrls: ['../common/dialog-style.css']
})
export class ChangeCustomerOwnerDialogComponent extends BaseDialogComponent<ChangeCustomerOwnerDialogComponent> {

  parentId?: string;
  parentCustomer?: Customer;
  filteredCustomers?: Observable<any>;
  customerSelectionControl = new FormControl('');
  public customerService = inject(CustomerService);

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    super();
    this.parentId = undefined;
    this.filterCustomer_init()
  }


  //------
  // Filterable customer List
  //------
  filterCustomer_init(){
    this.filteredCustomers = this.customerSelectionControl.valueChanges.pipe(
      startWith(''),
      map( value => {
        if(!!value) {
          const title = typeof value === 'string' ? value : (value as unknown as Customer).title;
          return title ? this._filter(title as string) : this.data.allCustomers!.slice()
        } else {
          return this.data.allCustomers!.slice()
        }
      }),
    );
  }

  private _filter(value: string): Customer[] {
    const filterValue = value.toLowerCase();
    return this.data.allCustomers!.filter((x: Customer)=> x.title.toLowerCase().includes(filterValue));
  }
  displayFn(customer: Customer): string {
    return customer? customer.title : '';
  }
  checkSelection(): boolean {
    if(typeof this.customerSelectionControl.value != 'object') {
      return !!this.customerSelectionControl.value;
    } else {
      return false;
    }
  }
  //------

  changeCustomerOwner() {

    const cb = new ChangeCustomerOwnerCB();
    cb.i.id = this.data.customer.id;
    cb.i.newOwnerId = this.parentId;

    this.customerService.changeCustomerOwner(cb).subscribe(
      () => {
        this.closeDialog(true);
      }, error => {
        this.gmService.openErrorSnackbar(error);
      }
    );
  }

  typeof(value: any) {
    return typeof value;
  }
}



/*--------------------------------
     DELETE CUSTOMER COMPONENT
 -------------------------------*/

@Component({
  templateUrl: '../common/are-u-sure-delete-dialog.html',
  selector: 'app-are-u-sure-delete-dialog',
  styleUrls: ['../common/dialog-style.css']
})
export class AreUSureDeleteCustomerDialogComponent extends BaseDialogComponent<AreUSureDeleteCustomerDialogComponent> {

  entity = "Cliente";

  constructor(@Inject(MAT_DIALOG_DATA) public customerTitle: string) {
    super();
  }

}
